import React from "react";
import { toBRDate } from "../../../core/cimInterdicoes.utils";
import InterdicaoListaCardShell, { PanelBlock } from "./InterdicaoListaCardShell";

function toBRDateTime(value, hour) {
  if (!value) return "-";
  return hour ?`${toBRDate(value)} às ${hour}` : toBRDate(value);
}

export default function InterdicaoListaViaCard({ item, onOpen }) {
  return (
    <InterdicaoListaCardShell
      item={item}
      onOpen={onOpen}
      layoutClassName="interd-listRowMain interd-listRowMain--via"
    >
      <div className="interd-listCol interd-listCol--data">
        <div className="interd-panelGrid">
          <PanelBlock label="Início" value={toBRDateTime(item.dataInicio, item.horaInicio)} />
          <PanelBlock
            label="Previsão de término"
            value={item.temPrevisao ?toBRDateTime(item.dataFim, item.horaFim) : "Sem previsão"}
            muted={!item.temPrevisao}
          />
        </div>
      </div>

      <div className="interd-listCol interd-listCol--trecho">
        <div className="interd-panelGrid interd-panelGrid--triplet">
          <PanelBlock label="SB" value={item.sb || "-"} />
          <PanelBlock label="SUB" value={item.sub || "-"} />
          <PanelBlock
            label="KM"
            value={item.kmFinal ?`${item.kmInicial || "-"} até ${item.kmFinal}` : item.kmInicial || "-"}
            wide
          />
        </div>
      </div>

      <div className="interd-listCol interd-listCol--acionamento">
        <div className="interd-panelGrid">
          <PanelBlock label="Identificador" value={item.identificador || item.codigoUnico || "-"} accent />
          <PanelBlock label="Acionamento" value={item.acionamento || "-"} />
        </div>
      </div>

      <div className="interd-listCol interd-listCol--motivo">
        <div className="interd-panelGrid">
          <PanelBlock label="Motivo" value={item.motivo || "-"} accent />
          <PanelBlock
            label="Observação"
            value={item.observacao || "Sem observação"}
            multiline
            muted={!item.observacao}
          />
          {item.coordenada ?<PanelBlock label="Complemento" value={item.coordenada} multiline /> : null}
        </div>
      </div>

      <div className="interd-listCol interd-listCol--cco">
        <div className="interd-panelGrid">
          <PanelBlock
            label="Número da interdição"
            value={item.numeroInterdicao || "Pendente"}
            pending={!item.numeroInterdicao}
          />
          <PanelBlock label="SB da interdição" value={item.sbInterdicao || "-"} />
        </div>
      </div>
    </InterdicaoListaCardShell>
  );
}
